<template>
  <div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg1.png"
      width="100%"
      v-show="mode === 'pc'"
    />
    <div style="position: relative;">
      <h3
        v-show="mode === 'mobile'"
        style="position: absolute; top: 40px; left: 5%"
      >
        {{ creativeType }}
      </h3>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/marquee/bg.png"
      width="100%"
      v-show="mode === 'mobile'"
    />
    <div class="ad"></div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      width="100%"
      v-show="mode === 'pc'"
    />
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      width="100%"
      v-show="mode === 'pc'"
    />
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      width="100%"
      v-show="mode === 'pc'"
    />
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      width="100%"
      v-show="mode === 'pc'"
    />
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg3.png"
      width="100%"
      v-show="mode === 'pc'"
    />
  </div>
</template>

<script>
import mixMobile from '@/components/mixins/mobile.js';
export default {
  data() {
    return {
      creativeId: this.$route.params.creativeId,
      mode: this.$route.query.mode,
      creativeType: '',
    };
  },
  mixins: [mixMobile],
  async created() {
    await store.dispatch('creative/getCreativeById', this.creativeId);
    const creative = store.getters['creative/getCreativeById'](this.creativeId);
    this.creativeType = creative._type;
    document.title = creative.name;
    if (!this.mode) {
      this.mode = [
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY
          .PARALLAX_SCROLLING_WITH_OUTSTREAM,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.PARALLAX_SCROLLING_FLIP,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.CARDS,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SCROLLINGBOX,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SPINNER,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROLLING_CASTLE,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.MARQUEE,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.ROTATINGFERRISWHELL,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SWITCH,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.SWAP,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.COUNT_DOWN,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD,
        CONSTANT.ENUM_CREATIVE_DISCRIMINATOR_KEY.POST_AD_WITH_OUTSTREAM,
      ].includes(creative._type)
        ? 'mobile'
        : 'pc';
    }
    if (this.mode === 'mobile') {
      this.viewport();
      this.setMobileCSS();
    }

    let target = document.querySelector('.ad');
    let ifr = document.createElement('iframe');
    ifr.srcdoc = getTemplate(creative);
    ifr.style.setProperty('display', 'none');
    target.appendChild(ifr);
  },
  methods: {
    setMobileCSS() {
      let style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
      html {
        margin: 0px auto !important;
      }
      body {
        margin: 0px !important;
      }
      @media only screen and (min-width: 1280px){
        html, body, body > div, iframe + div {
          max-width: 400px !important;
        }
        body > div, iframe + div{
          left: auto !important;
        }
        body > div > div:not(.ucmarquee-container) , iframe + div > div{
          overflow: hidden !important;
        }
      }`;
      document.head.appendChild(style);
    },
  },
};
</script>
<style lang="sass" scoped>
.ad
  text-align: center
</style>
